import { useStorage } from '@vueuse/core'
import { cloneDeep, has, isEqual, isNull } from 'lodash'
import { computed, ref } from 'vue'

import { isLocalStorageAvailable } from '@/utils/persist'
import { MCP_REDIRECT_PAYLOAD_KEY } from '@/utils/query-parameters'
import { isTimestampExpired } from '@web-app/utils/stores-timestamp'

const DEFAULT_REDIRECT_PARAMS = {
  params: null,
  expiry: null
}

export const useOboardMCP = () => {
  const redirectParamsState = isLocalStorageAvailable()
    ? useStorage('redirect-params-store', cloneDeep(DEFAULT_REDIRECT_PARAMS))
    : ref(cloneDeep(DEFAULT_REDIRECT_PARAMS))

  const setState = (newState = DEFAULT_REDIRECT_PARAMS) => {
    redirectParamsState.value = cloneDeep(newState)
  }

  const isMcpLoginApp = computed(() => {
    return !isEqual(redirectParamsState.value, DEFAULT_REDIRECT_PARAMS)
  })

  const resetMcpRedirectParamsStore = () => setState(DEFAULT_REDIRECT_PARAMS)

  const revokeMcpRedirectParams = () => {
    redirectParamsState.value.expiry = DEFAULT_REDIRECT_PARAMS.expiry
  }

  const validateMcpRedirectParams = () => {
    const isRedirectParamsExist = !isNull(redirectParamsState.value.params)

    const isValid = isRedirectParamsExist && !isTimestampExpired(redirectParamsState.value.expiry)

    if (!isValid) {
      resetMcpRedirectParamsStore()
    }

    return isValid
  }

  const isUserCameForMCPConnection = route => route && has(route.query, MCP_REDIRECT_PAYLOAD_KEY)

  return {
    isMcpLoginApp,
    redirectParamsState,
    resetMcpRedirectParamsStore,
    revokeMcpRedirectParams,
    validateMcpRedirectParams,
    isUserCameForMCPConnection,
    setState
  }
}
